import {
  CollectionEntriesDocument,
  CollectionEntriesQuery,
  CollectionEntryFragment,
  withNewStandardListHook,
} from '@spotify/confidence-graphql';

interface CollectionEntriesVariables {
  parent: string;
}

export const useCollectionEntries = withNewStandardListHook<
  CollectionEntriesQuery,
  CollectionEntryFragment,
  'collectionEntries',
  CollectionEntriesVariables
>(CollectionEntriesDocument, 'collectionEntries', {
  typename: 'CollectionsV1ListCollectionEntriesResponse',
  fragmentName: 'CollectionEntry',
});
